import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod, PostMethod } from "../../../Service/ApiCallMethod";
import { LIMIT_PER_PAGE } from "../../../Common/Constants";

export const getCustomerList = createAsyncThunk(
  "customer/getCustomerList",
  async (customerId, thunkAPI) => {
    try {
      const response = await getMethod(
        "customer?keyword=" +
          customerId.searchText +
          `&limit=${customerId?.limit ?? LIMIT_PER_PAGE}&page=` +
          customerId.page +
          `&sortBy=${customerId?.sortBy ?? "createdAt"}&sortOrder=${
            customerId?.sortOrder ?? "DESC"
          }`
      );
      const data = await response.data;
      if (response.status != 200 && response.status != 201) {
        // Handle non-2xx HTTP responses
        return thunkAPI.rejectWithValue(data.message || "Something went wrong");
      }
      return data; // Assuming the response contains customer data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Network error");
    }
  }
);

const initialState = {
  customerDetails: null, // Assuming single customer data object
  loading: false,
  error: null,
};

export const getCustomerListSlice = createSlice({
  name: "login",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCustomerList.fulfilled, (state, action) => {
        state.loading = false;
        state.customerDetails = action.payload;
        state.error = null; // Clear any previous errors
      })
      .addCase(getCustomerList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default getCustomerListSlice.reducer;
